@if (!useSummaryView) {
  @if (!field.hidden) {
    <div class="flex flex-col w-full" animate.enter="fade-in">
      <div class="flex flex-row items-center w-full">
        @if (field.browserOpts.inLineWithCaption) {
          <mat-label class="mr-2 mb-4 font-medium">{{ field.label|
            localize }}
          </mat-label>
        }
        <mat-form-field class="w-full">
          <mat-label>{{ field.label | localize }}</mat-label>
          <mat-chip-grid #chipGrid class="p-2" [formControl]="field.control">
            @for (chip of field.control.value; track chip; let i = $index) {
              <mat-chip-row [value]="chip"
                [selectable]="false" [selected]="false" [removable]="!field.control.disabled"
                (removed)="removeChip(i)" [editable]="!field.control.disabled" (edited)="editChip(i, $event)">
                {{ chip }}
                @if (!field.control.disabled) {
                  <mat-icon class="icon-size-5" matChipRemove
                  svgIcon="heroicons_solid:minus-circle"></mat-icon>
                }
              </mat-chip-row>
            }
            <input [matChipInputFor]="chipGrid" [placeholder]="field.placeholder | localize"
              [matChipInputAddOnBlur]="true" [matChipInputSeparatorKeyCodes]="separators"
              (matChipInputTokenEnd)="addChip($event.value); $event.input.value = ''"
              [readonly]="field.readonly" [required]="field.required" autocomplete="off" (paste)="paste($event)" />
            </mat-chip-grid>
            @if (field.hint) {
              <mat-hint>{{ field.hint | localize }}</mat-hint>
            }
            @if (!field.readonly && field.control.errors) {
              <mat-error>
                @if (field.control.hasError('validateArrayNotEmpty')) {
                  {{ 'errorRequiredField' | transloco }}
                }
                @if (field.control.hasError('minlength')) {
                  {{ 'errorMinLengthField' | transloco:{ requiredLength: field.control.errors.minlength.requiredLength } }}
                }
                @if (field.control.hasError('maxlength')) {
                  {{ 'errorMaxLengthField' | transloco:{ requiredLength: field.control.errors.maxlength.requiredLength } }}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }
  } @else {
    {{ displayedValue }}
  }

